import { useEffect, useState } from "react";
import bibtexParse from "bibtex-parse-js";

function parseBibFile(jsonText) {
  return jsonText.map((entry) => ({
    id: entry.citationKey,
    type: entry.entryType,
    title: entry.entryTags.title || "",
    course: entry.entryTags.course || "",
    course_code: entry.entryTags.course_code || "",
    school: entry.entryTags.school || "",
    year: entry.entryTags.year || "",
    semester: entry.entryTags.semester
  }));
}

function BibEntry({ entry }) {
  return (
    <div className="bibentry">
        <ul>
            <li>
                <strong>{entry.title}</strong>
                <i>
                {entry.course?<span> of {entry.course}</span>:""}
                {entry.school
                ?<span>{entry.course
                    ?<span>. ({entry.course_code?<span>{entry.course_code}, </span>:""}{entry.school})</span>
                    :<span> at {entry.school}</span>}</span>
                :""},&nbsp;
                {entry.semester?<span>{entry.semester}, </span>:""}
                {entry.year}
                </i>
            </li>
        </ul>
    </div>
  );
}

function BibList({ entries }) {
  if (!entries.length) return <p className="text-gray-500">불러오는 중...</p>;

  const sem = (str)=>{
    if(str==="Fall") return 3;
    else if(str==="Spring") return 2;
    else return 1;
  };
  const sorted = [...entries].sort((a, b) => {return ((b.year || 0) === (a.year || 0))?(sem(b.semester)-sem(a.semester)):((b.year || 0) - (a.year || 0))});

  return (
    <div>
      {sorted.map((entry) => (
        <BibEntry key={entry.id} entry={entry} />
      ))}
    </div>
  );
}

export default function TeachingExp() {
    const [teachings, setTeachings] = useState([]);

    useEffect(() => {
    async function loadBib() {
        try {
        const response = await fetch("/Data/teaching.bib");
        const text = await response.text();
        const jsonText = bibtexParse.toJSON(text);
        var teachinglist = [];
        jsonText.forEach((cur) =>{
            if(cur.entryType === 'teaching') teachinglist.push(cur);
        });
        setTeachings(parseBibFile(teachinglist));
        } catch (error) {
            console.error("Failed to load BibTeX:", error);
        }
    }
    loadBib();
    }, []);
    return(
        <div className = "TeachingExp">
            <h2>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chalkboard-teacher" className="svg-inline logo_hsize" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"></path></svg>
              Teacing Experience
            </h2>
            <BibList entries={teachings} />
        </div>
    );
}